import React, { useState } from "react";
import styled from "styled-components";
import logo from "../images/logo.png";

const NavBar = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
    {/* 🔴 FREE SHIPPING BAR */}
    <TopBar>
      FREE SHIPPING ON ORDERS ABOVE $50 →
    </TopBar>
    <Header>
      <LogoSection>
        <img src={logo} alt="Software Marketing Logo" />
      </LogoSection>

      <Kebab onClick={() => setOpen(!open)}>
        ⋮
      </Kebab>

      <Nav open={open}>
        <ul>
          <li><a href="index1.html">Home</a></li>
          <li><a href="#">About</a></li>
          <li><a href="#">Pricing</a></li>
          {/* <li><a href="#">Blog</a></li> */}
          {/* <li><a href="surveyPage.html">Survey</a></li> */}
          <li><a href="#">Contact</a></li>
          {/* <li><a href="#">Features</a></li> */}
        </ul>
      </Nav>
    </Header>
    </>
  );
};

export default NavBar;

/* ---------------- STYLED COMPONENTS ---------------- */

/* TOP RED STRIP */
const TopBar = styled.div`
  width: 100%;
  background: #ff0000; /* bold red */
  color: white;
  text-align: center;
  padding: 10px 0;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0rem 3rem;
  background: transparent;
  color: black;
  font-weight: bold;
  position: relative;
`;

const LogoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  img {
    height: 80px;
    width: auto;
  }
`;

/* Kebab Menu Icon */
const Kebab = styled.div`
  font-size: 30px;
  cursor: pointer;
  display: none;

  @media (max-width: 850px) {
    display: block;
  }
`;

/* Navigation */
const Nav = styled.nav`
  ul {
    list-style: none;
    display: flex;
    gap: 20px;
  }

  a {
    text-decoration: none;
    color: black;
    font-weight: 700;
    font-size: 16px;
  }

  /* Mobile View */
  @media (max-width: 850px) {
    position: absolute;
    top: 90px;
    right: 20px;
    background: white;
    padding: ${({ open }) => (open ? "14px 20px" : "0")};
    border-radius: 8px;
    box-shadow: ${({ open }) =>
      open ? "0px 4px 10px rgba(0,0,0,0.2)" : "none"};
    opacity: ${({ open }) => (open ? "1" : "0")};
    visibility: ${({ open }) => (open ? "visible" : "hidden")};
    transition: all 0.3s ease-in-out;

    ul {
      flex-direction: column;
      gap: 10px;
    }
  }
`;
